import { all, call, put, takeEvery } from "@redux-saga/core/effects";
import { factoryService } from "../../services/factory";
import { showErrorResponse } from "../../varibles/global";
import { IFactory } from "../../varibles/interface";
import { factoryActions } from "./reducer";


function* getsWatcher(): Generator {
    try {
        const data = yield call(factoryService.gets);
        yield put(factoryActions.getsSuccess(data as IFactory[]));
    } catch (error) {
        yield put(factoryActions.getsFailure())
        showErrorResponse('Get factories failure', error);
    }
}

function* getsByAdminWatcher(): Generator {
    try {
        const data = yield call(factoryService.getByAdmin);
        yield put(factoryActions.getsByAdminSuccess(data as IFactory[]));
    } catch (error) {
        yield put(factoryActions.getsByAdminFailure())
        showErrorResponse('Get factories failure', error);
    }
}

export default function* locationSaga() {
    yield all([
        takeEvery(factoryActions.gets.type, getsWatcher),
        takeEvery(factoryActions.getsByAdmin.type, getsByAdminWatcher),
    ])
}
